'use strict'

module.exports = ['$compile', '$http', 'moment', '$state', 'widgets',
    function ($compile, $http, moment, $state, widgets) {

        function getPartial (type) {
            return $http.get('/partial/app.helpers.' + type, {
                cache: true
            })
        }

        function setBlurType (scope) {

            let parseValue = value => {
                if (scope.type === 'checkbox') {
                    value = value === 'true' || value === '1'
                } else if (scope.type === 'number') {
                    value = parseInt(value)
                } else if (scope.type === 'multiselect') {
                    value = value.split(',')
                }
                return value
            }

            scope.model = parseValue(scope.yObject.get(scope.name).toString())

            let yObserver = () => {
                scope.$evalAsync(() => {
                    scope.model = parseValue(scope.yObject.get(scope.name).toString())
                })
            }

            scope.yObject.get(scope.name).observe(yObserver)

            let scopeObserver = function (newVal) {
                if (newVal === undefined) return
                let oldVal = scope.yObject.get(scope.name).toString()

                if (newVal.toString() !== oldVal) {
                    scope.yObject.get(scope.name).delete(0, oldVal.length)
                    scope.yObject.get(scope.name).insert(0, newVal.toString())
                }
            }

            let scopeUnReg = scope.$watch('model', scopeObserver)

            scope.$on('$destroy', function () {
                scopeUnReg()
                const yObjectField = scope.yObject.get(scope.name)
                if (yObjectField != null) yObjectField.unobserve(yObserver)
            })
        }

        function setRichTextType (scope) {
            scope.model = scope.yObject.get(scope.name).toString()
            scope.oldModel = scope.model

            scope.onChange = _.debounce(() => {
                const newValue = scope.model
                const yObject = scope.yObject.get(scope.name)

                if (scope.oldModel !== newValue) {
                    yObject.delete(0, yObject.length)
                    yObject.insert(0, newValue.toString())
                    scope.oldModel = newValue
                }
            }, 500)

            const yObserver = event => {
                if (!event.transaction.local) {
                    const newValue = scope.yObject.get(scope.name).toString()
                    if (scope.model !== newValue) {
                        scope.$applyAsync(() => {
                            scope.oldModel = scope.model = newValue
                        })
                    }
                }
            }

            scope.yObject.get(scope.name).observe(yObserver)
            scope.$on('$destroy', function () {
                const yObjectField = scope.yObject.get(scope.name)
                if (yObjectField != null) yObjectField.unobserve(yObserver)
            })
        }

        function setDateType (scope) {
            scope.model = scope.yObject.get(scope.name).toString()

            let yObserver = _.debounce(function () {
                scope.$evalAsync(() => {
                    let val = scope.yObject.get(scope.name).toString()
                    let dateTime = moment(val)

                    if (dateTime.isValid()) {
                        scope.model = dateTime.toISOString()
                    }
                })
            }, 100)

            scope.yObject.get(scope.name).observe(yObserver)

            let scopeObserver = newVal => {

                let newTimestamp = '',
                    isValid = true,
                    oldTimestamp = scope.yObject.get(scope.name).toString()

                if (newVal) {
                    newVal = newVal.toString().replace('Invalid date', '')
                    if (newVal) {
                        let date = moment.tz(newVal, window.CONFIG.timezone)

                        if (scope.type === 'date') {
                            date.startOf('day')
                        }

                        date.tz('utc')
                        newTimestamp = date.toISOString()
                        isValid = date.isValid()
                    }
                }

                if (isValid && newTimestamp !== oldTimestamp) {
                    scope.yObject.get(scope.name).delete(0, oldTimestamp.length)
                    scope.yObject.get(scope.name).insert(0, newTimestamp.toString())
                }
            }

            let scopeUnReg = scope.$watch('model', scopeObserver)

            scope.$on('$destroy', function () {
                scopeUnReg()
                const yObjectField = scope.yObject.get(scope.name)
                if (yObjectField != null) yObjectField.unobserve(yObserver)
            })
        }

        function setTextType (scope) {
            checkForElement('#custom-' + scope.name).then(() => {
                let yText = scope.yObject.get(scope.name)
                scope.model = yText.toString()
                let yObserver = () => {
                    scope.$evalAsync(() => {
                        scope.model = scope.yObject.get(scope.name).toString()
                    })
                }
                let unRegister = scope.$watch(() => {
                    return scope.model
                }, newVal => {
                    let oldVal = yText.toString()
                    if (oldVal !== newVal && oldVal != null && newVal != null) {
                        yText.delete(0, oldVal.length)
                        yText.insert(0, newVal)
                    }
                })
                yText.observe(yObserver)
                scope.$on('$destroy', () => {
                    unRegister()
                    yText.unobserve(yObserver)
                })
            })
        }

        function setUrlType (scope) {
            checkForElement('#custom-' + scope.name).then(() => {
                scope.model = scope.yObject.get(scope.name).toString()

                let yObserver = function () {
                    scope.$evalAsync(() => {
                        scope.model = scope.yObject.get(scope.name).toString()
                    })
                }

                scope.yObject.get(scope.name).observe(yObserver)

                let scopeObserver = function (newVal) {
                    if (newVal == null) return
                    let oldVal = scope.yObject.get(scope.name).toString()
                    newVal = (newVal || '').toString()

                    if (newVal !== oldVal) {
                        scope.yObject.get(scope.name).delete(0, oldVal.length)
                        scope.yObject.get(scope.name).insert(0, newVal)
                    }
                }

                let scopeUnReg = scope.$watch('model', scopeObserver)

                scope.$on('$destroy', function () {
                    const yObjectField = scope.yObject.get(scope.name)
                    if (yObjectField != null) yObjectField.unobserve(yObserver)
                    scopeUnReg()
                })
            })
        }

        function setFacebookType (scope) {
            checkForElement('#custom-' + scope.name).then((el) => {
                let initUnparsed = scope.yObject.get(scope.name).toString()
                let initVal

                try {
                    initVal = JSON.parse(initUnparsed)
                } catch (e) {
                    initVal = {}
                }

                scope.model = initVal

                let yObserver = function () {
                    this.$scope.$evalAsync(() => {
                        let unparsedNew = scope.yObject.get(scope.name).toString()
                        let newVal

                        try {
                            newVal = JSON.parse(unparsedNew)
                        } catch (e) {
                            newVal = {}
                        }

                        //this.formdata.field_values[customField.name] = newVal;
                        angular.extend(scope.model, newVal)
                    })
                }

                scope.yObject.get(scope.name).observe(yObserver)

                let blurObserver = function () {
                    let unparsedOld = scope.yObject.get(scope.name).toString()
                    let oldVal

                    try {
                        oldVal = JSON.parse(unparsedOld)
                    } catch (e) {
                        oldVal = {}
                    }

                    let newVal = scope.model

                    if (!angular.equals(oldVal, newVal)) {
                        scope.yObject.get(scope.name).delete(0, unparsedOld.length)
                        scope.yObject.get(scope.name).insert(0, JSON.stringify(newVal))
                    }
                }

                el.blur()

                scope.$on('$destroy', function () {
                    const yObjectField = scope.yObject.get(scope.name)
                    if (yObjectField != null) yObjectField.unobserve(yObserver)
                    el.off('blur', blurObserver)
                })
            })
        }

        function setWidgetType (scope, uniqueWidgetId) {
            scope.model = scope.yObject.get(scope.name).toString()

            let yObserver = _.debounce(() => {
                scope.$evalAsync(() => {
                    const newValue = scope.yObject.get(scope.name).toString()
                    if (scope.model !== newValue) {

                        scope.model = newValue

                        if (uniqueWidgetId) {
                            widgets.sendMessage(uniqueWidgetId, 'updateWidget', JSON.parse(scope.model))
                        }
                    }
                })
            }, 100)

            scope.yObject.get(scope.name).observe(yObserver)

            let scopeObserver = function (newVal, oldVal) {
                const yField = scope.yObject.get(scope.name)

                if (oldVal !== newVal) {
                    yField.delete(0, yField.toString().length)
                    yField.insert(0, newVal)
                }
            }

            let unRegisterScope = scope.$watch('model', scopeObserver)

            scope.$on('$destroy', function () {
                const yObjectField = scope.yObject.get(scope.name)
                if (yObjectField != null) yObjectField.unobserve(yObserver)
                unRegisterScope()
            })
        }

        function checkForElement (elName) {
            return new Promise((resolve) => {
                let bindOnElement = () => {
                    let bindOnEl = angular.element(elName)
                    if (bindOnEl.length > 0) {
                        resolve(bindOnEl)
                    } else {
                        setTimeout(bindOnElement, 100)
                    }
                }

                bindOnElement()
            })
        }

        function waitTillYObjectIsReady (scope) {
            return new Promise((resolve) => {
                let checkYObj = function () {
                    if (scope.yObject.get(scope.name) == null) {
                        setTimeout(checkYObj, 5)
                    } else {
                        resolve()
                    }
                }

                checkYObj()
            })
        }

        return {
            restrict: 'E',
            scope: {
                title: '=',
                name: '=',
                model: '=',
                yObject: '=',
                options: '=',
                type: '=',
                form: '=',
                fieldId: '=',
                details: '=',
                pbreadonly: '=',
                stationId: '=',
                widget: '=',
                rmType: '@',
                rmId: '='
            },
            link (scope, element) {
                let uniqueWidgetId, readonlyModelPlaceholder = scope.model
                scope.uniqueUpdatedHash = Math.floor(Math.random() * 0xffffffff).toString(36)

                if (scope.widget) {
                    uniqueWidgetId = 'field_' + scope.widget.id + '_' + scope.name
                }

                if (scope.yObject) {
                    waitTillYObjectIsReady(scope).then(() => {
                        switch (scope.type) {

                            case('select'):
                            case('checkbox'):
                            case('multiselect'):
                            case('number'):
                            case('time'):
                                setBlurType(scope)
                                break

                            case('richtext'):
                                setRichTextType(scope)
                                break

                            case('datetime'):
                            case('date'):
                                setDateType(scope)
                                break

                            case('text'):
                            case('uuid'):
                            case('textarea'):
                            case('email'):
                                setTextType(scope, element)
                                break

                            case('url'):
                            case('image_url'):
                                setUrlType(scope)
                                break

                            case('facebook'):
                                setFacebookType(scope)
                                break

                            default:
                                if (scope.widget) {
                                    setWidgetType(scope, uniqueWidgetId)
                                }
                                break
                        }
                    })
                }

                // In case types need to be converted
                if (scope.type === 'date') {
                    scope.model = scope.model ? new Date(scope.model) : new Date()

                    if (scope.options && scope.options.min) {
                        scope.options.min = new Date(scope.options.min)
                    }
                    if (scope.options && scope.options.max) {
                        scope.options.max = new Date(scope.options.max)
                    }
                }

                scope.isReadonly = () => {
                    if (scope.options && scope.options.static) {
                        return readonlyModelPlaceholder
                    } else {
                        return false
                    }
                }

                scope.onBlur = () => {
                    if (scope.options && scope.options.static) {
                        readonlyModelPlaceholder = scope.model
                    }
                }

                function setDatetimeModel () {
                    if (scope.timeModel) {
                        scope.model = moment(moment(scope.dateModel).format('YYYY-MM-DD') + ' ' + scope.timeModel).toISOString()
                    }
                }

                if (scope.type === 'datetime') {

                    scope.$watch('model', (newVal) => {
                        if (typeof newVal != 'undefined') {
                            scope.dateModel = moment(newVal)
                            scope.timeModel = moment(scope.dateModel).format('HH:mm:ss')
                        }
                    })

                    scope.dateModel = new Date()
                    scope.timeModel = '00:00:00'
                    if (scope.model) {
                        let dateModel = moment(scope.model)
                        scope.dateModel = dateModel.toDate()
                        scope.timeModel = moment(dateModel).format('HH:mm:ss')
                    }

                    scope.$watch('timeModel', setDatetimeModel)
                    scope.$watch('dateModel', setDatetimeModel)
                }

                if (scope.widget) {
                    let stationId = scope.stationId || window.CONFIG.station_id
                    widgets.createWidgetFrame(
                        uniqueWidgetId,
                        scope.widget,
                        {
                            title: scope.title,
                            name: scope.name,
                            readOnly: !!scope.pbreadonly,
                            type: scope.rmType
                        },
                        scope.rmType + '-' + scope.rmId,
                        (data, iframe) => {
                            switch (data.action) {
                                case('registered'):
                                    break
                                case('save'):
                                    if (!scope.pbreadonly) {
                                        scope.$apply(() => {
                                            scope.model = JSON.stringify(data.actionData.content)
                                        })
                                    }
                                    break
                                case('height-update'):
                                    iframe.style.height = data.actionData.newHeight + 'px'
                                    break
                            }
                        },
                        () => ([
                            scope.model ? JSON.parse(scope.model) : null,
                            { readOnly: !!scope.pbreadonly }
                        ]),
                        {}, // @todo add extra data fields
                        stationId
                    ).then(iframe => {
                        iframe.id = 'widget-' + scope.widget.id
                        iframe.className = 'field-widget'
                        element.html(iframe)

                        scope.$on('$destroy', () => {
                            widgets.unRegisterWidget(uniqueWidgetId)
                        })
                    })
                } else {
                    getPartial(scope.type)
                        .catch(err => {
                            console.error('customFieldError', err)
                            return {
                                data: `<h1 style="color:#f00">Data model error in field <code style="background:#ccc;color:#000">${scope.title}</code></h1>`
                            }
                        })
                        .then(response => {
                            element.html(response.data)
                            $compile(element.contents())(scope)
                        })
                }
            }
        }
    }
]

